import { Main } from './main'
import { useState, useEffect } from 'react'
import { LoginPage } from './pages/login-page'
import { ThreeDots } from 'react-loader-spinner'

import './app.scss'
import './fonts/GothamLight.otf'
import { useDispatch } from 'react-redux'
import {
  changeLevel,
  changeUsername
} from './services/redux-reducers/user-settings/user-settings-reducer'
import { pingSession, SESSION_STATUS } from './services/session'

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [fetching, setFetching] = useState(true)
  const [loginError, setLoginError] = useState(null)
  const dispatch = useDispatch()
  // const [fetching] = useState(true)

  useEffect(() => {
    pingSession().then(({ code, data }) => {
      setFetching(false)

      if (code === SESSION_STATUS.EXPIRED) {
        setIsLoggedIn(false)
      }

      if (code === SESSION_STATUS.ACTIVE) {
        dispatch(changeUsername(data.username))
        dispatch(changeLevel(data.level))
        setIsLoggedIn(true)
      }
    })
  }, [])

  const handleOnLoginSuccess = () => {
    setLoginError(null)
    setIsLoggedIn(true)
  }

  const handleOnLogout = (reason) => {
    setLoginError(reason === 'session-expired' ? 'sessionExpired' : null)
    setIsLoggedIn(false)
  }

  const renderLoading = () => {
    return (
      <div className="loading-login-wrapper">
        <ThreeDots height={200} width={200} color="#202c8a" />
      </div>
    )
  }

  const renderContent = () => {
    if (isLoggedIn) {
      return <Main onLogout={handleOnLogout} />
    }

    return <LoginPage onLoginSuccess={handleOnLoginSuccess} initialError={loginError} />
  }

  return <div className="App">{fetching ? renderLoading() : renderContent()}</div>
}

export default App
